// extracted by mini-css-extract-plugin
export default {"megatron":"Megatron_megatron__KGRPI","image-container":"Megatron_image-container__QN9I8","fade-in":"Megatron_fade-in__x3cMA","dropdown":"Megatron_dropdown__-UN7W"};